import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { DateClick } from '@/hooks/affiliate/useAffiliateAnalytics';

interface ClicksOverTimeChartProps {
  data: DateClick[];
}

export const ClicksOverTimeChart = ({ data }: ClicksOverTimeChartProps) => {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Affiliate Clicks Over Time</CardTitle>
        <CardDescription>Daily affiliate partner click trends</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="clicks" 
              stroke="hsl(var(--primary))" 
              strokeWidth={2}
              name="Affiliate Clicks"
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
